import {
  FaGithubAlt,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";

const SOCIALS = [
  {
    name: "GitHub",
    icon: FaGithubAlt,
    url: "https://github.com/gauravlonari",
  },
  {
    name: "LinkedIn",
    icon: FaLinkedin,
    url: "https://linkedin.com/in/gauravlonari",
  },
  {
    name: "Twitter",
    icon: FaTwitter,
    url: "https://twitter.com/lonarigaurav",
  },
  {
    name: "Instagram",
    icon: FaInstagram,
    url: "https://instagram.com/lonari_gaurav_95",
  },
];

export default SOCIALS;
